/** @jsx jsx */
import { jsx, Flex, Spinner } from 'theme-ui'
// Informational message display on resource overview grid
const LoadingSpinner = props => (
  <Flex m="5" {...props} sx={{ justifyContent: 'center' }}>
    <Spinner
      role="progressbar"
      aria-valuetext="loading data"
      aria-label="loading"
    />
  </Flex>
)

export default LoadingSpinner
